import * as React from 'react';

const PurchaseSvg = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.60229 7.64114V9.97447C3.60229 10.404 3.94812 10.7523 4.37767 10.7523H10.1446C10.5742 10.9138 10.92 10.404 10.92 9.97447V7.64114H11.7115V9.97447C11.7115 10.8336 11.0037 11.6916 10.1446 11.53H4.37767C3.51856 11.53 2.8269 10.8336 2.8269 9.97447V7.64114H3.60229ZM6.87698 7.70894V2.03516H7.65476V7.70894L9.3335 6.03171C9.4819 5.88344 9.7224 5.88355 9.87067 6.03196C10.0211 6.18448 10.0206 6.42687 9.87124 6.577L7.26587 9.19624L4.65373 6.57845C4.5035 6.4279 4.50363 6.18411 4.65402 6.03371C4.8044 5.88333 5.04819 5.88323 5.1987 6.03348L6.87698 7.70894Z"
      fill="#595D70"
      stroke="#595D70"
      stroke-width="0.161538"
    />
  </svg>
);
export default PurchaseSvg;
